import { render, staticRenderFns } from "./StarPower.vue?vue&type=template&id=9c90aeec&scoped=true&lang=html"
import script from "./StarPower.vue?vue&type=script&lang=js"
export * from "./StarPower.vue?vue&type=script&lang=js"
import style0 from "./StarPower.vue?vue&type=style&index=0&id=9c90aeec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c90aeec",
  null
  
)

export default component.exports